export const ChargesQuantityColumn = (cellContext: any) => {
  const {
    row: { original: subscription },
  } = cellContext;

  return <div className="whitespace-normal">{subscription.charges_count}</div>;
};
